function Palestine({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1874)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M9.73908 10.4348H31.0047C28.7441 4.342 22.8793 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L9.73908 10.4348Z" fill="black"/>
  <path d="M9.73908 21.5645H31.0047C28.7441 27.6573 22.8793 31.9993 15.9999 31.9993C11.5816 31.9993 7.58202 30.2081 4.68677 27.3125L9.73908 21.5645Z" fill="#6DA544"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Palestine;
